module.exports = __webpack_public_path__ + "static/scale-model-of-provo-pioneer-village-in-provo-utah-8f2b54609fd9e91b15ec0802a1264d3d.png";